var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"py-0",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_vm._v("/")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }